import * as React from 'react';

function isChunkLoadError(err: unknown): boolean {
  const msg = String((err as any)?.message ?? err);

  // Common error messages for missing route chunks
  return (
    /ChunkLoadError/i.test(msg) ||
    /Loading chunk/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

export function lazyRetry<T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
  opts?: { storageKey?: string },
): React.LazyExoticComponent<T> {
  const storageKey = opts?.storageKey ?? 'vite_chunk_reload_once';

  return React.lazy(async () => {
    try {
      return await importer();
    } catch (err) {
      if (isChunkLoadError(err)) {
        // Reload at most once per tab session to avoid infinite loops
        if (sessionStorage.getItem(storageKey) !== '1') {
          sessionStorage.setItem(storageKey, '1');
          window.location.reload();
          // Prevent React from continuing rendering with a failed lazy import
          return new Promise(() => {}) as any;
        }
      }
      throw err;
    }
  });
}
